import React from "react";

const AboutInfo = () => {
  return (
    <div id="aboutInfo">
      <div className="mt-5 mb-5">
      {/* About Us Section */}
      <div className="section">
        <div className="container">
          <div className="row text-left mb-5">
            <div className="col-12">
              <h2 className="font-weight-bold heading text-primary mb-4">
                About Corbiltek
              </h2>
            </div>

            <div className="col-lg-12">
              <p className="text-black-50" style={{ fontSize: "18px" }}>
                When we design with purpose and build with trust, great spaces come to life. 
                At <span style={{ fontSize: "20px", fontWeight: "600" }}>
                <a href="/" className="text-decoration-none text-primary">CORBILTEK</a>
                </span>, we blend creativity, technical expertise, and innovation to deliver 
                complete construction and design solutions — from concept to completion.
              </p>

              <p className="text-black-50" style={{ fontSize: "18px" }}>
                With a passionate team of skilled architects, civil engineers, and project 
                planners, we focus on providing accurate floor plans, stunning 3D elevations, 
                seamless permit approvals, precise cost estimations, and smooth documentation 
                for every project we undertake.
              </p>

              <p className="text-black-50" style={{ fontSize: "18px" }}>
                We believe in collaboration, transparency, and craftsmanship — ensuring every 
                client’s vision is transformed into a reality that stands the test of time. 
                Every design, every brick, and every detail reflects our commitment to quality 
                and excellence.
              </p>

              <p className="text-black-50" style={{ fontSize: "18px" }}>
                Whether you’re planning your dream home or a large-scale commercial development, 
                partnering with <strong>Corbiltek</strong> means working with a reliable, 
                experienced, and passionate team that delivers quality, value, and satisfaction 
                at every stage.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section with Image on Right */}
      <div className="section pt-0">
        <div className="container">
          <div className="row justify-content-between mb-5">
            <div className="col-lg-7 mb-5 mb-lg-0 order-lg-2">
              <div className="img-about dots">
                <img
                  src="assets/images/hero_bg_3.jpg"
                  alt="About Corbiltek"
                  className="img-fluid rounded shadow"
                />
              </div>
            </div>
            <div className="col-lg-4">
              {[
                {
                  icon: "icon-home2",
                  title: "Innovative Designs",
                  desc: "We create functional, aesthetic, and sustainable designs that elevate every space.",
                },
                {
                  icon: "icon-person",
                  title: "Expert Professionals",
                  desc: "Our experienced architects, engineers, and project managers ensure precision at every step.",
                },
                {
                  icon: "icon-security",
                  title: "Quality & Trust",
                  desc: "We build long-term trust by delivering top-quality results on time and within budget.",
                },
              ].map((item, i) => (
                <div className="d-flex feature-h mb-4" key={i}>
                  <span className="wrap-icon me-3">
                    <span className={item.icon}></span>
                  </span>
                  <div className="feature-text">
                    <h3 className="heading text-primary">{item.title}</h3>
                    <p className="text-black-50" style={{ fontSize: "17px" }}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      
    </div>
    </div>
  );
};

export default AboutInfo;
